import React, {memo} from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {GifModel} from '../../../../models/api/gifModel';
import {IntegrationModel} from '../../../../models/api/integrationModel';
import {CommentComposerAddContent} from './commentComposerAddContent';
import {CommentComposerEmoji} from './commentComposerEmoji';
import {CommentComposerExpandToggle} from './commentComposerExpandToggle';
import {CommentComposerGif} from './commentComposerGif';
import {CommentComposerMention} from './commentComposerMention';
import {CommentComposerSummarize} from './CommentComposerSummarize';

/*
 * Props.
 */

interface CommentComposerControlsProps {
  className?: string;
  conversationId: number | undefined;
  isDisabled?: boolean;
  hasAICompose: boolean;

  zoomIntegration?: IntegrationModel;
  onFileUpload: HandlerOf<File>;
  onEmojiSelect: HandlerOf<string>;
  onGifSelect: HandlerOf<GifModel>;
  onInsertCommentComposerText: HandlerOf<string>;
  onControlDropdownOpen: HandlerOf<boolean | undefined>;
  onMentionClick: Handler;
  isExpanded: boolean;
  onExpandToggleClick?: Handler;
  companyUrl: string;
}

/*
 * Style.
 */

const StyledCommentControlsDiv = styled.div`
  padding: 3px 2px;

  display: flex;
  flex-direction: row;
  flex: none;
`;

/*
 * Component.
 */

export const CommentComposerControls = memo<CommentComposerControlsProps>((props) => {
  const {
    onFileUpload,
    onEmojiSelect,
    onGifSelect,
    onControlDropdownOpen,
    onMentionClick,
    onInsertCommentComposerText,
    hasAICompose,
  } = props;

  return (
    <StyledCommentControlsDiv className={props.className}>
      <CommentComposerAddContent
        conversationId={props.conversationId}
        isDisabled={props.isDisabled}
        onInsertCommentComposerText={onInsertCommentComposerText}
        zoomIntegration={props.zoomIntegration}
        onFileUpload={onFileUpload}
        onFileDropdownOpen={onControlDropdownOpen}
      />
      <CommentComposerMention isDisabled={props.isDisabled} onMentionClick={onMentionClick} />
      <CommentComposerEmoji
        conversationId={props.conversationId}
        isDisabled={props.isDisabled}
        onEmojiSelect={onEmojiSelect}
        onEmojiDropdownOpen={onControlDropdownOpen}
      />
      <CommentComposerGif
        conversationId={props.conversationId}
        isDisabled={props.isDisabled}
        onGifSelect={onGifSelect}
        onGifDropdownOpen={onControlDropdownOpen}
      />
      {hasAICompose && props.conversationId && (
        <CommentComposerSummarize
          conversationId={props.conversationId}
          onInsertCommentComposerText={onInsertCommentComposerText}
          isDisabled={props.isDisabled}
          companyUrl={props.companyUrl}
        />
      )}
      {props.onExpandToggleClick && (
        <CommentComposerExpandToggle
          isExpanded={props.isExpanded}
          isDisabled={props.isDisabled}
          onClick={props.onExpandToggleClick}
        />
      )}
    </StyledCommentControlsDiv>
  );
});
